// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__iGKxG","text":"SelectPayment_text__2dJlY","title":"SelectPayment_title__ktT7l","btn":"SelectPayment_btn__1g3Of"};